import RestaurantList from "@/restaurant/views/RestaurantList.vue";
import RestaurantBooking from "@/restaurant/views/RestaurantBooking.vue";
import { createWebHashHistory, createRouter } from "vue-router";

const RestaurantRoutes = [
    {
        path: "",
        name: "restaurant_list",
        component: RestaurantList,

    },
    {
        path: "/dining/book/:id",
        name: "restaurant_booking",
        component: RestaurantBooking,

    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        ...RestaurantRoutes
    ],
    scrollBehavior(/*to, from, savedPosition*/) {
        return { top: 0 }
    },

});

export default router;